export const GET_ALLBLOGLIST_REQUEST="GET_ALLBLOGLIST_REQUEST";
export const GET_ALLBLOGLIST_SUCESS="GET_ALLBLOGLIST_SUCESS";
export const GET_ALLBLOGLIST_FAILURE="GET_ALLBLOGLIST_FAILURE";

export const GET_IDBLOGLIST_REQUEST="GET_IDBLOGLIST_REQUEST";
export const GET_IDBLOGLIST_SUCESS="GET_IDBLOGLIST_SUCESS";
export const GET_IDBLOGLIST_FAILURE="GET_IDBLOGLIST_FAILURE";


export const GET_USERBLOGLIST_REQUEST="GET_USERBLOGLIST_REQUEST";
export const GET_USERBLOGLIST_SUCESS="GET_USERBLOGLIST_SUCESS";
export const GET_USERBLOGLIST_FAILURE="GET_USERBLOGLIST_FAILURE";



export const DELETE_USERBLOGLIST_REQUEST="DELETE_USERBLOGLIST_REQUEST";
export const DELETE_USERBLOGLIST_SUCESS="DELETE_USERBLOGLIST_SUCESS";
export const DELETE_USERBLOGLIST_FAILURE="DELETE_USERBLOGLIST_FAILURE";



export const UPDATE_USERBLOGLIST_REQUEST="UPDATE_USERBLOGLIST_REQUEST";
export const UPDATE_USERBLOGLIST_SUCESS="UPDATE_USERBLOGLIST_SUCESS";
export const UPDATE_USERBLOGLIST_FAILURE="UPDATE_USERBLOGLIST_FAILURE";


export const POST_USERBLOGLIST_REQUEST="POST_USERBLOGLIST_REQUEST";
export const POST_USERBLOGLIST_SUCESS="POST_USERBLOGLIST_SUCESS";
export const POST_USERBLOGLIST_FAILURE="POST_USERBLOGLIST_FAILURE";







